import script from "./playerRecruiterLikes.vue?vue&type=script&setup=true&lang=js"
export * from "./playerRecruiterLikes.vue?vue&type=script&setup=true&lang=js"

import "./playerRecruiterLikes.vue?vue&type=style&index=0&id=6e1d7bc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e1d7bc8"]])

export default __exports__